import {
    SET_ACTIVE_ASSET_EXCEL_DATA,
    SET_ACTIVE_ASSET_GRID_FILTERS,
    SET_ACTIVE_ASSET_GRID_DATA,
    SET_IS_GRID_DATA_LOADING
} from "./ActiveAssetDashboardType";

const initialState = {
    activeAssetExcelData: null,
    activeAssetGridFilters: {},
    activeAssetGridData: null,
    isGridDataLoading: false
}

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ACTIVE_ASSET_EXCEL_DATA:
            return {
                ...state,
                activeAssetExcelData: action.activeAssetExcelData,
            };
        case SET_ACTIVE_ASSET_GRID_FILTERS:
            return {
                ...state,
                activeAssetGridFilters: { ...state.activeAssetGridFilters, ...action.activeAssetGridFilters },
            };
        case SET_ACTIVE_ASSET_GRID_DATA:
            return {
                ...state,
                activeAssetGridData: action.activeAssetGridData,
            };
        case SET_IS_GRID_DATA_LOADING:
            return {
                ...state,
                isGridDataLoading: action.isGridDataLoading,
            };
        default:
            return state;
    }
}

export default reducers